var lists_default = {
  "fontElementMap": "BOON4",
  "orderedlist": "v6Oo2",
  "bulletedlist": "eON6s",
  "listItem": "h4V1a"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists.scss.js.map
